import api from '../../plugins/api';

const editProfile = (params) => {
  return api.post('/editProfile', params);
};

export default editProfile;
